import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  display: flex;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: rgb(245 245 245);
  z-index: 1;
  overflow-y: auto;
  padding-bottom: 20px;
  @media (max-width: 768px) {
    padding: 28px 8px;
    background-image: none;
    margin-top: -15px;
    padding-bottom: 53px;
    border-radius: 15px 15px 0 0;
  }
`;

export const Body = styled.main`
  display: flex;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const ImageWeb = styled.img`
  @media (max-width: 768px) {
    display: none;
  }
`;

export const ImageMobile = styled.img`
  @media (min-width: 769px) {
    display: none;
  }
`;

export const SideBanner = styled.div`
  width: 100%;
  max-width: 425.14px;
  height: 100%;
  background: ${({ theme }) => theme.gradient.top};

  padding: 49px 0px 0px 60px;

  > a {
    @media (max-width: 768px) {
      display: flex;
    }
  }

  svg {
    color: white;
    margin-bottom: 88.69px;
    height: 36.31px;
    width: 173.42px;
    path,
    .a {
      color: white;
      fill: white !important;
    }
  }

  img {
    margin-bottom: 88.69px;
    color: white;
    @media (max-width: 768px) {
      margin-bottom: 15px;
    }
  }

  @media (max-width: 769px) {
    padding: 25px 22.21px 15px 25px;
    max-width: 100%;

    svg {
      margin-bottom: 0px;
    }
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  background: rgb(255, 255, 255);
  padding: 19px 20px;
  position: sticky;
  top: 0px;
  z-index: 20;
  box-shadow: rgba(0, 0, 0, 0.8) 0px 2px 100px -35px;

  @media (max-width: 769px) {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
  }
`;

export const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  span {
    font-size: 0.75rem;
    color: #5e5e5e;
    margin-bottom: 22px;
    color: ${({ theme }) => theme.colors.gray};

    display: flex;
    align-items: center;
  }

  h1 {
    font-size: 1.4375rem;
    margin-bottom: 12px;
    color: ${({ theme }) => theme.colors.blue};
  }

  h2 {
    font-size: 0.9375rem;
    margin-bottom: 18px;
    color: ${({ theme }) => theme.colors.gray};
    line-height: 30px;
    font-weight: 400px;
  }

  p {
    color: ${({ theme }) => theme.colors.black};
    font-weight: bold;
  }
`;

export const Title = styled.h1`
  font-size: 16px;
  color: rgb(0, 0, 255);
  font-family: "Mangueira bold";
  font-weight: 700;
  line-height: 24px;
  margin: 0px;
  text-transform: capitalize;
`;

export const IconTitle = styled.div`
  color: rgb(0, 255, 255);
  font-size: 16px;
  font-family: "Mangueira bold";
  margin-right: 5px;
`;

export const ButtonLogin = styled.button`
  background: #000fff;
  padding: 8px 24px;
  color: #fff;
  font-family: "Mangueira bold";
  font-size: 12px;
  border: none;
  outline: none !important;
  cursor: pointer;
  text-transform: uppercase;
  border-radius: 8px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const Overlay = styled.div`
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 20;
  top: 0;
  left: 0;
`;

export const IconMenuWrapper = styled.div`
  svg {
    cursor: pointer;
    width: 28px !important;
    height: 28px !important;
    margin: unset;
    path {
      color: rgb(0, 0, 255) !important;
      fill: rgb(0, 0, 255) !important;
    }
  }
`;
